import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user-service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit{

  constructor(private userService: UserService, private router: Router){};

  role: string = "";
  name: string = "";

  ngOnInit() {
    let loggedUser = localStorage.getItem('loggedUser');
    if (loggedUser) {
      this.name = JSON.parse(loggedUser)?.name;
      this.role = JSON.parse(loggedUser)?.role;
    }
  }

  handleLogout() {
    this.userService.logout().subscribe(response => {
      this.router.navigateByUrl('/')
    });
  }
}
